var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.798,
    height: 88.909,
    viewBox: "0 0 85.798 88.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cudzyslow",
    transform: "translate(0.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1479",
    "data-name": "Group 1479",
    transform: "translate(-0.031 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M93.7,72l.543.3a4.869,4.869,0,0,0-.527-.254c0-.011-.008-.028-.015-.047",
    transform: "translate(-52.058 -40.001)",
    fill: "#cba04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M122.867,76.722a.667.667,0,0,1-.6-.955l9.925-20.71c-2.318.66-4.222.52-5.664-.42l-.03-.017c-2.123-1.4-3.155-4.4-3.155-9.154,0-10.121,4.993-18.137,14.842-23.827,5-2.89,8.732-3.581,11.393-2.113,2.77,1.527,4.116,5.239,4.116,11.348,0,11.455-6.957,26.318-20.679,44.174a.664.664,0,0,1-.432.253l-9.618,1.413a.709.709,0,0,1-.1.007m9.777-23.171a.667.667,0,0,1,.611.4l.328.754a.667.667,0,0,1-.01.554l-9.563,19.954,8.112-1.191c13.43-17.523,20.238-32.038,20.238-43.148,0-5.5-1.153-8.926-3.427-10.18-2.187-1.206-5.579-.5-10.082,2.1-9.406,5.435-14.175,13.063-14.175,22.673,0,4.2.854,6.9,2.54,8.03l.008,0c1.25.813,2.991.835,5.208.086a.663.663,0,0,1,.214-.036",
    transform: "translate(-67.894 -10.434)",
    fill: "#cba04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M40.372,105.788a.662.662,0,0,1-.325-.085c-2.326-1.3-3.457-4.356-3.457-9.33,0-10.126,5-18.144,14.846-23.831,4.643-2.678,8.174-3.463,10.8-2.4a.667.667,0,0,1-.5,1.236c-2.186-.885-5.427-.105-9.631,2.32-9.408,5.432-14.179,13.061-14.179,22.676,0,4.386.934,7.134,2.775,8.167a.667.667,0,0,1-.326,1.248",
    transform: "translate(-20.329 -38.716)",
    fill: "#cba04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M34.688,143.88a.667.667,0,0,1-.6-.955l9.931-20.705a6.962,6.962,0,0,1-5.369-.245.667.667,0,0,1,.645-1.167c1.2.667,2.872.647,4.965-.06a.666.666,0,0,1,.823.364l.328.75a.668.668,0,0,1-.009.555l-9.571,19.954,8.112-1.188c7.9-10.309,13.56-19.64,16.813-27.734a44.2,44.2,0,0,0,3.39-13.879.655.655,0,0,1,.7-.629.667.667,0,0,1,.63.7,45.506,45.506,0,0,1-3.483,14.3c-3.32,8.264-9.092,17.773-17.157,28.264a.665.665,0,0,1-.432.253l-9.619,1.409a.719.719,0,0,1-.1.007",
    transform: "translate(-18.902 -54.971)",
    fill: "#cba04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M97.155,84.525h-.033a.668.668,0,0,1-.635-.7c.024-.5.039-1,.039-1.538a21.82,21.82,0,0,0-.826-6.579,6.009,6.009,0,0,0-2.6-3.6,4.277,4.277,0,0,0-.456-.22.666.666,0,1,1,.5-1.235,5.6,5.6,0,0,1,.6.288,7.271,7.271,0,0,1,3.22,4.356,23.1,23.1,0,0,1,.892,6.992c0,.559-.012,1.083-.039,1.6a.667.667,0,0,1-.665.633",
    transform: "translate(-51.243 -39.227)",
    fill: "#cba04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M107.238,138.876a.663.663,0,0,1-.322-.083l-12.5-6.894a.667.667,0,1,1,.644-1.167l12.5,6.894a.667.667,0,0,1-.322,1.251",
    transform: "translate(-52.265 -72.588)",
    fill: "#cba04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M102.468,92.371a.667.667,0,0,1-.6-.955l3.033-6.322a.667.667,0,1,1,1.2.577l-3.033,6.322a.667.667,0,0,1-.6.379",
    transform: "translate(-56.561 -47.068)",
    fill: "#cba04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M92.064,32.7a.66.66,0,0,1-.633-.466c0-.005-.006-.02-.008-.025a19.1,19.1,0,0,1-.685-5.527c0-10.128,4.992-18.143,14.839-23.823,5.011-2.893,8.74-3.586,11.4-2.116L132.1,9.093a.667.667,0,1,1-.644,1.167L116.33,1.915c-2.185-1.208-5.578-.5-10.086,2.1C96.84,9.443,92.072,17.07,92.072,26.687a17.851,17.851,0,0,0,.617,5.108c.008.022.015.044.018.056a.671.671,0,0,1-.451.825.681.681,0,0,1-.192.028",
    transform: "translate(-50.414 0)",
    fill: "#cba04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M15.785,164.054a.663.663,0,0,1-.322-.083L.344,155.629a.667.667,0,0,1-.279-.872l9.17-19.128a.667.667,0,1,1,1.2.576l-8.9,18.56L16.108,162.8a.667.667,0,0,1-.322,1.251",
    transform: "translate(0 -75.145)",
    fill: "#cba04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M21.491,95.367a.67.67,0,0,1-.322-.084L6.05,86.942C3.7,85.647,2.559,82.588,2.559,77.588c0-10.119,5-18.136,14.847-23.827,5.006-2.891,8.733-3.582,11.393-2.113l15.127,8.345a.667.667,0,1,1-.644,1.167L28.154,52.815c-2.187-1.207-5.579-.5-10.082,2.1C8.663,60.351,3.892,67.979,3.892,77.588c0,4.408.943,7.162,2.8,8.187l15.12,8.342a.667.667,0,0,1-.323,1.25",
    transform: "translate(-1.422 -28.28)",
    fill: "#cba04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M114.581,88.853a.663.663,0,0,1-.3-.071l-13.965-7.4a.667.667,0,0,1,.624-1.178L114.88,87.59a.667.667,0,0,1-.3,1.263",
    transform: "translate(-55.54 -44.519)",
    fill: "#cba04b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.d6fbb08fa994627291dcbf391c6d3ea3.svg";
export { ForwardRef as ReactComponent };